import { useState } from 'react'

import {
	EuiPopover,
	EuiPopoverTitle,
	EuiFieldSearch,
	EuiFilterGroup,
	EuiFilterButton,
	EuiLoadingSpinner,
	EuiSpacer,
} from '@equipmentshare/ds2'

import {
	ArrowDownSLineIcon,
	ArrowUpSLineIcon,
} from '@equipmentshare/ds2-icons'
import { FilterPopoverProps } from './types'

export default function FilterPopoverEui( {
	label,
	children,
	hasSearch,
	searchVal,
	setSearchVal,
	isLoading,
	renderFooter,
	...props }: FilterPopoverProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )
	const togglePopover = () => setIsPopoverOpen( !isPopoverOpen )
	const closePopover = () => setIsPopoverOpen( false )

	const button = (
		<EuiFilterButton
			iconType={isPopoverOpen ? ArrowUpSLineIcon : ArrowDownSLineIcon}
			iconSide="right"
			isSelected={isPopoverOpen}
			onClick={togglePopover}
			{...props}
		>
			{label}
		</EuiFilterButton>
	)

	return (
		<EuiFilterGroup>
			<EuiPopover
				button={button}
				isOpen={isPopoverOpen}
				closePopover={closePopover}
				panelPaddingSize="none"
			>
				{ hasSearch && setSearchVal && (
					<EuiPopoverTitle>
						<EuiFieldSearch
							compressed
							value={searchVal}
							onChange={setSearchVal}
						/>
					</EuiPopoverTitle>
				) }
				<div className="euiFilterSelect__items">
					{children}
				</div>
				{ isLoading && (
					<div className="euiFilterSelect__note">
						<div className="euiFilterSelect__noteContent">
							<EuiLoadingSpinner size="m" />
							<EuiSpacer size="xs" />
							<p>Loading...</p>
						</div>
					</div>
				) }
				{ renderFooter?.( { closePopover } ) }
			</EuiPopover>
		</EuiFilterGroup>
	)
}
